(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/customer-settings-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/customer-settings-service.js');
'use strict';

const jupiter = svs.core.jupiter;

const getCustomersSettingsAsync = async function () {
  let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  svs.myProfile.logger.debug('CommunicationSettingsService:getCustomersSettingsAsync start...');
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');

  if (useOldJupiterApi || c !== '' && i !== '') {
    try {
      var _rply$response, _rply$response4, _rply$response5;
      let path = '/player/1/settings';
      if (c !== '' && i !== '') {
        path = "/player/1/settings/guid?assignedKey=".concat(c, "&customerId=").concat(i);
      }
      const rply = await jupiter.callAsync({
        method: 'GET',
        path
      });
      if ((_rply$response = rply.response) !== null && _rply$response !== void 0 && _rply$response.error) {
        var _rply$response2, _rply$response3;
        svs.myProfile.logger.error('getCustomersSettingsAsync error response from jupiter:', (_rply$response2 = rply.response) === null || _rply$response2 === void 0 ? void 0 : _rply$response2.error);
        return {
          error: (_rply$response3 = rply.response) === null || _rply$response3 === void 0 ? void 0 : _rply$response3.error,
          settings: {}
        };
      }
      return {
        error: (_rply$response4 = rply.response) === null || _rply$response4 === void 0 ? void 0 : _rply$response4.error,
        settings: (_rply$response5 = rply.response) === null || _rply$response5 === void 0 ? void 0 : _rply$response5.settings
      };
    } catch (err) {
      svs.myProfile.logger.error('CommunicationSettingsService:getCustomersSettingsAsync error...', err);
      return {
        error: err,
        settings: {}
      };
    }
  }
  try {
    const elzaPath = '/preferences/v1/customers/me';
    const svsFetch = svs.core.svsFetch.create();
    const response = await svsFetch(elzaPath, {
      method: 'GET'
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: 'unauthorized',
          settings: {}
        };
      }
      let errorDetail = 'Error fetching customer settings';
      try {
        const errorResult = await response.json();
        errorDetail = errorResult.title || errorResult.detail || errorDetail;
        svs.myProfile.logger.warn("Error fetching customer settings (Elza): ".concat(errorResult.type), errorDetail);
      } catch (_unused) {
        svs.myProfile.logger.error('Error fetching customer settings (Elza)', response.status);
      }
      return {
        error: errorDetail,
        settings: {}
      };
    }
    const result = await response.json();
    svs.myProfile.logger.debug('getCustomersSettingsAsync response from elza:', result);
    return {
      error: null,
      settings: (result === null || result === void 0 ? void 0 : result.data) || {}
    };
  } catch (err) {
    svs.myProfile.logger.error('CommunicationSettingsService:getCustomersSettingsAsync error from elza...', err);
    return {
      error: err,
      settings: {}
    };
  }
};

const putCustomersSettingsAsync = async function (settings) {
  let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  svs.myProfile.logger.debug("putCustomersSettingsAsync c: ".concat(c, ", i: ").concat(i));
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');

  if (useOldJupiterApi || c !== '' && i !== '') {
    try {
      let path = '/player/1/settings';
      const data = {
        settings
      };
      if (c !== '' && i !== '') {
        path = '/player/1/settings/guid';
        data.assignedKey = c;
        data.customerId = i;
      }
      const _await$jupiter$callAs = await jupiter.callAsync({
          method: 'PUT',
          path,
          data
        }),
        response = _await$jupiter$callAs.response,
        status = _await$jupiter$callAs.status;
      if (status !== 'success') {
        svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync error response from jupiter:', response.error);
        return {
          status,
          error: response.error
        };
      }
      svs.myProfile.logger.debug('CommunicationSettingsService:setCustomersSettingsAsync success response from jupiter');
      return {
        status,
        error: response.error
      };
    } catch (err) {
      svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync error from jupiter:', err);
      return {
        status: 'error',
        error: err
      };
    }
  }
  try {
    const preferences = settings.reduce((acc, setting) => {
      acc[setting.key] = setting.value;
      return acc;
    }, {});
    const elzaPath = '/preferences/v1/customers/me';
    const svsFetch = svs.core.svsFetch.create();
    const response = await svsFetch(elzaPath, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(preferences)
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          status: 'error',
          error: 'unauthorized'
        };
      }
      const body = await response.json().catch(() => null);
      const errors = (body === null || body === void 0 ? void 0 : body.errors) || [];
      const errorDetail = (body === null || body === void 0 ? void 0 : body.detail) || 'Error saving customer settings';
      svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync error response from elza:', response.status, errorDetail, JSON.stringify(errors));
      return {
        status: 'error',
        error: errorDetail,
        errors
      };
    }
    svs.myProfile.logger.debug('CommunicationSettingsService:setCustomersSettingsAsync success response from elza');
    return {
      status: 'success',
      error: null
    };
  } catch (err) {
    svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync error from elza:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.shared.customerSettingsService = {
  putCustomersSettingsAsync,
  getCustomersSettingsAsync
};

 })(window);